import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "./AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Zalogowano pomyślnie");
      navigate(location.state?.from || "/forum");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Zaloguj się" subtitle="Dostęp do strefy członkowskiej i forum">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div>
          <Label htmlFor="email">E-mail</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-1.5" />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Hasło</Label>
            <Link to="/forgot-password" className="text-xs text-ztk-blue hover:underline" data-testid="login-forgot-link">Nie pamiętasz hasła?</Link>
          </div>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1.5" />
        </div>
        {error && <p className="rounded-lg bg-destructive/10 px-3 py-2 text-sm text-destructive" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full bg-ztk-blue hover:bg-ztk-navy800" data-testid="login-submit-button">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Zaloguj się
        </Button>
      </form>
      <p className="mt-6 text-center text-sm text-muted-foreground">
        Nie masz konta?{" "}
        <Link to="/rejestracja" className="font-medium text-ztk-blue hover:underline" data-testid="login-register-link">Dołącz do Izby</Link>
      </p>
    </AuthShell>
  );
}
